import _ from 'underscore';
import {SELECTION_CHANGED} from 'common/constants';
import {PointScopeEnum} from 'common/proxies/enum-proxy';
import {precedence} from 'common/utils/meter-util';
import SelectorBaseView from 'common/views/selector-base-view';
import SelectorGroups from 'common/templates/selector-groups.html';
import {t} from 'common/utils/translation-util';

export default SelectorBaseView.extend({
  getMeters(facility, facilities) {
    for (let ii = 0, nn = facilities.length; ii < nn; ii++) {
      if (facilities[ii].urlElement === facility) {
        return facilities[ii].points;
      }
    }
  },

  getMeterGroups(facility) {
    const facilities = this.collection.getFacilities();
    const meters = this.getMeters(facility, facilities);
    const meterGroups = [];
    const scopes = {};
    for (const meter of meters) {
      const scope = meter.scope;
      if (!scopes[scope.slug]) {
        scopes[scope.slug] = {};
        if (scope.slug === PointScopeEnum.WHOLE.slug) {
          // Special logic for Whole Building optgroup: visually split Meters
          // And Bills into two separate groups that are on top.
          const name = scope.displayName.toUpperCase();
          const wholeBills = meters.filter((datum) => datum.bill);
          const wholeMeters = meters.filter((datum) => !datum.bill);
          meterGroups.unshift({
            label: t('%(name)s BILL', {name}),
            options: this.getOptions(wholeBills, scope),
          });
          meterGroups.unshift({
            label: t('%(name)s POINT', {name}),
            options: this.getOptions(wholeMeters, scope),
          });
        } else {
          meterGroups.push({
            label: scope.displayName.toUpperCase(),
            options: this.getOptions(meters, scope),
          });
        }
      }
    }
    return meterGroups.sort((aa, bb) => aa.label.localeCompare(bb.label));
  },

  getOptions(meters, scope) {
    const options = [];
    for (let ii = 0, nn = meters.length; ii < nn; ii++) {
      const meter = this.validateMeter(meters[ii]);
      if (meter && meter.scope.slug === scope.slug) {
        const option = {
          text: meter.displayName.toLowerCase(),
          type: meter.type,
          value: meter.systemName,
        };
        options.push(option);
      }
    }
    if (scope.slug === PointScopeEnum.WHOLE.slug) {
      return this.getOptionsSortedByPrecedence(options);
    }
    return options.sort((aa, bb) => aa.text.localeCompare(bb.text));
  },

  getOptionsSortedByPrecedence(options) {
    const groups = _.groupBy(options, (datum) => {
      return datum.type.slug;
    });
    const sorted = [];
    const unsorted = [];
    for (const propName in groups) {
      if ({}.hasOwnProperty.call(groups, propName)) {
        const group = groups[propName];
        let groupHasRule = false;
        for (let ii = 0, nn = precedence.length; ii < nn; ii++) {
          const meterType = precedence[ii];
          if (meterType.slug === propName) {
            groupHasRule = true;
            sorted[ii] = group;
            break;
          }
        }
        if (!groupHasRule) {
          unsorted.push(group);
        }
      }
    }
    return _.flatten(sorted.concat(unsorted));
  },

  render(facility, isSilent) {
    const meterGroups = this.getMeterGroups(facility);
    const template = _.template(SelectorGroups);
    const options = template({optionGroups: meterGroups});
    this.$el.html(options);
    this.select2();
    // Sometimes you don't want to trigger the event
    // (like when restoring selectors during back button usage)
    if (!isSilent) {
      this.trigger(SELECTION_CHANGED, {
        selection: this.getSelectedItem(),
        target: this,
      });
    }
  },

  validateMeter(meter) {
    // Override
    // Gives sub-modules a chance to
    // Do something with a meter
    // Before it's sent for rendering.
    // This is a good place to exclude
    // Meters that don't satisfy
    // Certain conditions.
    if (meter.disabled) {
      return false;
    }
    return meter;
  },
});
